import React from 'react';

/**
 * Logo CUALAPP - componente reutilizable.
 *
 * Diseño original: Ricardo Javier Zheng Morillo (2026).
 * Versión tornasol (purple-blue) procesada del PNG original del autor.
 *
 * Props:
 *  - size: numero (px) o string CSS. Default 32.
 *  - animated: true => shimmer animado superpuesto (uso interno de la app).
 *              false => version estatica (recomendado para impresion / SAPI / docs).
 *  - withWordmark: true => muestra "CUALAPP" al lado del logo.
 *  - className: clases adicionales del wrapper.
 */
const CualappLogo = ({ size = 32, animated = true, withWordmark = false, className = '' }) => {
  const px = typeof size === 'number' ? `${size}px` : size;
  const fontPx = typeof size === 'number' ? `${Math.round(size * 0.62)}px` : '1.25rem';
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="cualapp-logo">
      <span
        className={`relative inline-block overflow-hidden ${animated ? 'cualapp-logo-shimmer' : ''}`}
        style={{ width: px, height: px, lineHeight: 0 }}
      >
        <img
          src="/logo-cualapp.png"
          alt="CUALAPP"
          style={{ width: '100%', height: '100%', display: 'block' }}
          draggable="false"
        />
      </span>
      {withWordmark && (
        <span
          className="font-bold tracking-tight bg-gradient-to-r from-purple-600 via-violet-600 to-blue-600 bg-clip-text text-transparent"
          style={{ fontSize: fontPx }}
        >
          CUALAPP
        </span>
      )}
    </span>
  );
};

export default CualappLogo;
